module.exports = __webpack_public_path__ + "img/Washi-tape-bottom-left.05ab2428.svg";